import { Context, Effect, Layer } from 'effect'
import type { AppType } from '~/features/app-type'
import { IntercomAnalyticsService } from '~/features/analytics/providers/intercom'

export type SupportChatLauncherConfig = {
  visible: boolean
  bottom: number
  right: number
}

export type SupportChatService = {
  configureLauncher: (config: SupportChatLauncherConfig) => Effect.Effect<void>
}

export class SupportChat extends Context.Service<SupportChat, SupportChatService>()(
  'SupportChat'
) {}

export function supportChatNoopLayer() {
  return Layer.succeed(SupportChat, { configureLauncher: () => Effect.void })
}

export function supportChatLayer(appType: AppType) {
  if (appType == 'organization') {
    return Layer.succeed(SupportChat, {
      configureLauncher: IntercomAnalyticsService.configureLauncher
    })
  }

  return supportChatNoopLayer()
}
